import { ThumbaCoin, ThumbaTrophyIcon } from "@roman/shared/components/Icons";
import type { RankedUser } from "@roman/shared/types/WebUser";
import { cn } from "@roman/shared/utils";
import { pointsToYen } from "@roman/shared/utils/pointsToYen";
import { forwardRef } from "react";
import { Avatar } from "./Avatar";

type UserRowProps = {
  user: RankedUser;
  rank?: number;
  className?: string;
};

export const UserRow = forwardRef<HTMLDivElement, UserRowProps>(({ user, rank, className }, ref) => {
  return (
    <div key={user.id} ref={ref} className={cn("flex items-center border-b bg-white py-3 px-5", className)}>
      <div className="flex-1 flex gap-2.5 items-center">
        <div className="text-dark-gray text-center font-normal text-[16px] leading-normal">{rank}</div>
        <Avatar user={user} />
        <div className="font-medium text-[14px] leading-normal text-black">{user.name}</div>
      </div>
      <div className="flex flex-col items-end gap-[5px]">
        <div className="flex items-center gap-1">
          <ThumbaCoin className="w-4 h-4" />
          <span className="font-bold text-[18px] leading-[25.2px] tracking-[-0.36px] text-black">
            {Number(user.freePoints).toLocaleString()} pt
          </span>
        </div>

        {user.potentialRedeemablePoints && (
          <span className="flex items-center gap-1 text-right font-bold text-[14px] leading-normal text-[#A67606]">
            <ThumbaTrophyIcon className="w-4 h-4" />
            <span className="text-[10px]"> {pointsToYen(user.potentialRedeemablePoints)}円</span>
          </span>
        )}
      </div>
    </div>
  );
});
